document.addEventListener('DOMContentLoaded', () => {
    const fakeDateInputs = document.querySelectorAll('.form__fake');
    if (!fakeDateInputs.length) return;

    const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent) || ('ontouchstart' in window);
    const isSmallScreen = window.matchMedia('(max-width: 767px)').matches;

    if (isMobile || isSmallScreen) {
        fakeDateInputs.forEach(input => {
            const placeholder = input.getAttribute('placeholder');
            input.type = 'date';

            const span = document.createElement('span');
            span.className = 'form__date-placeholder';
            span.textContent = placeholder;
            input.closest('label').style.position = 'relative';
            input.closest('label').appendChild(span);

            input.addEventListener('change', () => {
                span.style.display = input.value ? 'none' : '';
            });
        });
        return;
    }

    fakeDateInputs.forEach(input => {
        input.addEventListener('focus', () => { input.type = 'date'; });
        input.addEventListener('blur', () => { if (!input.value) input.type = 'text'; });
    });
});
